<template>
  <div
    class="group flex h-full w-full"
    :data-youtube-visible="isVisible ? '1' : '0'"
    data-el="youtube-video"
  >
    <YoutubePopup v-if="isVisible" :video-id="videoId" @click="clicked" />
    <button
      class="relative flex h-full min-h-32 w-full items-center justify-center overflow-hidden rounded-xl lg:min-h-32"
      data-el="youtube-video-button"
      type="button"
      :data-id="videoId"
      title="Play video"
      :style="`background-size: cover; background-position: center right; background-repeat: no-repeat; background-image: url('${thumbnailSrc}')`"
      @click="onClick"
    >
      <span
        class="absolute bottom-0 left-0 right-0 top-0 z-10 bg-black opacity-10"
        data-el="thumbnail-mask"
      />
      <Icon
        class="absolute z-10 text-7xl text-white/70 drop-shadow-2xl group-hover:scale-110"
        data-el="thumbnail-play"
        icon="videoPlay"
      />
    </button>
  </div>
</template>
<script setup lang="ts">
import { ref } from 'vue';
import YoutubePopup from '../../components/video/YoutubePopup.vue';
import Icon from '../../components/Icon.vue';

import { useNuxtApp } from '#imports';
const { $captureEvent: captureEvent } = useNuxtApp();
const props = defineProps<{
  videoId: string;
  thumbnailSrc: string;
}>();

const isVisible = ref(false);
const clicked = () => {
  isVisible.value = false;
};
const onClick = () => {
  isVisible.value = !isVisible.value;
  captureEvent('click_video', {
    videoId: props.videoId,
  });
};
</script>
